/**
 * @fileoverview Página responsável pela experiência principal de tickets em layout de múltiplos painéis.
 */

import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import MainContainer from "../../components/MainContainer";
import DynamicLogo from "../../components/DynamicLogo";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	chatContainer: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		padding: 0,
		height: "100%",
		overflow: "hidden",
		position: "sticky",
		top: 0,
	},

	chatPapper: {
		display: "flex",
		flex: 1,
		height: "100%",
		overflow: "hidden",
		alignItems: "stretch",
		position: "relative",
	},

	contactsWrapper: {
		display: "flex !important",
		flex: "0 0 33.333333% !important",
		maxWidth: "33.333333% !important",
		width: "33.333333% !important",
		minWidth: "33.333333% !important",
		flexDirection: "column",
		height: "100%",
		overflow: "hidden",
		position: "relative",
		borderRight: theme.palette.type === 'dark'
			? '1px solid rgba(91, 124, 255, 0.1)'
			: '1px solid rgba(0, 0, 0, 0.12)',
	},
	messagesWrapper: {
		display: "flex !important",
		flex: "0 0 66.666667% !important",
		maxWidth: "66.666667% !important",
		width: "66.666667% !important",
		minWidth: "66.666667% !important",
		flexDirection: "column",
		height: "100%",
		overflow: "hidden",
		position: "relative",
		background: theme.palette.type === 'light'
			? '#ffffff'
			: 'radial-gradient(ellipse 100% 100% at 50% 50%, #1A1A1A 0%, #1A1A1A 35%, #161618 60%, #121214 75%, #0E0E0F 85%, #0A0A0A 100%)',
	},
	welcomeMsg: {
		background: theme.palette.type === 'light'
			? '#ffffff'
			: 'radial-gradient(ellipse 100% 100% at 50% 50%, #1A1A1A 0%, #1A1A1A 35%, #161618 60%, #121214 75%, #0E0E0F 85%, #0A0A0A 100%)',
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
		border: 'none',
		boxShadow: 'none',
	},
}));

const TicketsCustom = () => {
	const classes = useStyles();
	const { ticketId } = useParams();
	const history = useHistory();

	useEffect(() => {
		if (!ticketId) return;
		const onKey = (e) => {
			if (e.key !== "Escape") return;
			const t = e.target;
			const typing =
				t?.isContentEditable ||
				["INPUT", "TEXTAREA"].includes(t?.tagName);
			if (typing) return;
			if (document.querySelector(".MuiDialog-root")) return;
			history.push("/tickets");
		};
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [ticketId, history]);

	return (
		<MainContainer>
			<div className={classes.chatContainer}>
				<div className={classes.chatPapper}>
					<Grid container spacing={0} wrap="nowrap" style={{ height: "100%", width: "100%", overflow: "hidden", position: "relative", display: "flex", alignItems: "stretch" }}>
						<Grid item xs={4} className={classes.contactsWrapper} style={{
							flex: '0 0 33.333333%',
							maxWidth: '33.333333%',
							width: '33.333333%',
							minWidth: '33.333333%'
						}}>
							<TicketsManager />
						</Grid>
						<Grid item xs={8} className={classes.messagesWrapper} style={{
							flex: '0 0 66.666667%',
							maxWidth: '66.666667%',
							width: '66.666667%',
							minWidth: '66.666667%'
						}}>
							{ticketId ? (
								<>
									<Ticket />
								</>
							) : (
								<div className={classes.welcomeMsg}>
									{/* PLW DESIGN VIDEO */}
									<div>
										<center><DynamicLogo style={{ margin: "0 auto", width: "70%" }} alt="logo" /></center>
									</div>
									{/* PLW DESIGN VIDEO */}
									{/*<span>{i18n.t("chat.noTicketMessage")}</span>*/}
								</div>
							)}
						</Grid>
					</Grid>
				</div>
			</div>
		</MainContainer>
	);
};

export default TicketsCustom;
